import CustomCheckbox from "../../../../../../components/CustomCheckbox";

const SyntaxAnalysisSelection = ({
  allTypes,
  selectedTypes,
  setSelectedTypes,
}) => {
  const handleLevelClick = (level) => {
    setSelectedTypes((prev) => {
      return prev.map((item) => {
        if (item.key === "syntax_analysis") {
          return {
            ...item,
            level,
          };
        }
        return item;
      });
    });
  };

  return (
    <>
      <div
        style={{
          fontSize: "16px",
          marginBottom: "10px",
        }}
      >
        구문분석 난이도 선택
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "30px",
        }}
      >
        {allTypes
          .find((type) => type.key === "syntax_analysis")
          .levels.map((level) => {
            return (
              <div
                key={level.key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <CustomCheckbox
                  checked={
                    selectedTypes.find(
                      (selectedType) => selectedType.key === "syntax_analysis"
                    ).level.key === level.key
                  }
                  onChange={() => handleLevelClick(level)}
                  disabled={setSelectedTypes === undefined}
                />
                {level.value}
              </div>
            );
          })}
      </div>
      {selectedTypes.find(
        (selectedType) => selectedType.key === "syntax_analysis"
      ).level.key !== "" && (
        <div
          style={{
            fontSize: "16px",
            color: "#737373",
            marginTop: "16px",
          }}
        >
          {
            selectedTypes.find(
              (selectedType) => selectedType.key === "syntax_analysis"
            ).level.text
          }
        </div>
      )}
    </>
  );
};

export default SyntaxAnalysisSelection;
